import Button from "@/src/components/Button";
import Modal from "@/src/components/Modal";
import { foodApi } from "@/src/utils/api/food";
import { toast } from "react-toastify";
import emptImage from "../../assets/img/emptFood.jpg";
import { useState, useEffect } from "react";

interface foodItemProps {
  open: boolean;
  close: () => void;
  data: any;
  setReload: (value: number) => void;
  reload: number;
}

function ModalFoodItem({
  open,
  close,
  data,
  setReload,
  reload,
}: foodItemProps) {
  const [price, setPrice] = useState<string>("");
  const [keyboardOpened, setKeyboardOpened] = useState(false);

  useEffect(() => {
    if (!open) {
      setKeyboardOpened(false);
    }
  }, [open]);

  return (
    <Modal open={open} onClose={close}>
      <div
        className={`w-full ${
          keyboardOpened ? "min-h-[250px] flex flex-col justify-center" : ""
        }`}
      >
        {!keyboardOpened && (
          <div className="w-full flex flex-col justify-center items-center mb-4">
            <img
              src={
                data?.foodImage
                  ? data.foodImage
                  : emptImage
              }
              className="h-[360px] w-[360px] rounded-xl"
              alt=""
            />
          </div>
        )}

        <div
          className={`flex gap-4 items-center ${
            keyboardOpened ? "mx-auto z-50" : ""
          }`}
        >
          <input
            type="number"
            value={price}
            onChange={(e) => {
              setPrice(e.target.value);
            }}
            placeholder="مبلغ مورد نظر را وارد کنید ...."
            className="py-2 w-[90%] border-gray-100-mmpz border rounded-lg px-2 placeholder:text-xs text-left placeholder:text-right"
            onFocus={() => {
              setKeyboardOpened(true);
            }}
          />
          <Button
            variant="default"
            size="small"
            className="w-[10%] min-w-[96px] text-xs py-3 rounded-lg"
            disabled={!price || parseFloat(price) < 0}
            onClick={() => {
              foodApi
                .updatePrice(data.foodId, parseFloat(price))
                .then(() => {
                  toast.success(
                    "درخواست شما با موفقیت ثبت شد، برای پیگیری درخواست به بخش ارتباط با تولید در اپلیکیشن مراجعه فرمایید"
                  );
                  close();
                  setReload(reload + 1);
                })
                .catch((err) => {
                  toast.error(err.response.data.message);
                });
            }}
          >
            ثبت درخواست
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default ModalFoodItem;
